import { useRef, memo } from 'react';
import { getThemeColor, legacyTheme } from 'styles/theme';
import { IconProps } from '../icon.props';
import { IconPresets } from '../icon.presets';

const SvgPrevious = memo((iconProps: IconProps) => {
  const ref = useRef();
  const {
    color: colorProp,
    height,
    strokeWidth,
    width,
    ...props
  } = { ...IconPresets, ...iconProps, ref };
  const color = getThemeColor(colorProp);
  return (
    <svg
      fillRule="evenodd"
      height="1em"
      viewBox="0 0 32 32"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16} cy={16} fill={color} fillRule="nonzero" r={16} />
      <path
        d="M19.396 22.638L17.932 24l-7.298-7.842 7.298-7.84 1.464 1.363-6.03 6.477z"
        fill="#fff"
      />
    </svg>
  );
});
export default SvgPrevious;
